"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var projectFormContext_1 = require("../../context/admin/projectFormContext");
var buttons_1 = require("../buttons");
var forms_1 = require("../lib/forms");
var ProjectFormContent = (function (_super) {
    __extends(ProjectFormContent, _super);
    function ProjectFormContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectFormContent.prototype.componentDidMount = function () {
        this.context.fetchProjectInformation();
    };
    ProjectFormContent.prototype.render = function () {
        var fields = this.context.formFields;
        return (React.createElement("div", { className: "mw-650" }, fields && (React.createElement(forms_1.Form, { fields: fields, onFormSubmit: this.context.onFormSubmit, formErrors: this.context.formErrors, className: "table_form", labelClasses: "col-md-4 col-xl-4 col-form-label", inputContainerClasses: "col-md-8 col-xl-8" },
            React.createElement("div", { className: "form-group row" },
                React.createElement("div", { className: "offset-md-4 offset-xl-4 col" },
                    React.createElement(buttons_1.PrimaryButton, { type: "submit", children: gettext("Save") })))))));
    };
    ProjectFormContent.contextType = projectFormContext_1.default;
    return ProjectFormContent;
}(React.Component));
var ProjectForm = function (props) {
    return (React.createElement(projectFormContext_1.ProjectFormContextProvider, { project_id: props.project_id },
        React.createElement(ProjectFormContent, null)));
};
exports.default = ProjectForm;
